export interface Article {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  coverImage: string;
  author: string;
  date: string;
  category: string;
  readTime: number;
}

// Helper functions for articles
export const getArticleBySlug = (articles: Article[], slug: string): Article | undefined => {
  return articles.find(article => article.slug === slug);
};

export const getAllCategories = (articles: Article[]): string[] => {
  const categories = articles.map(article => article.category);
  return categories.filter((category, index, self) => 
    self.indexOf(category) === index
  );
}; 